import s from './GetStarted.module.scss'

import React from 'react'
import { PopupAdapter } from 'shared/components/popups/PopupAdapter'
import { RegisterForm } from 'shared/components/RegisterForm'
import { GetStartedProps } from './GetStarted.types'
import { useLanguage } from 'context/LanguageContext'
import { getTranslation } from './translations'
import cn from 'classnames'

/** Кнопка GetStarted */
export const GetStarted: React.FC<GetStartedProps> = React.memo(({ type }) => {
    const { language } = useLanguage()
    const { buttonText } = getTranslation(language)

    return (
        <PopupAdapter
            component={RegisterForm}
            formId="regForm"
            buttonText={buttonText}
            buttonOption={{
                type: type,
                className: cn(s.tronLink, type !== 'primary' && s.noPrimary),
            }}
            modalOptions={{
                width: 480,
                footer: null,
                maskClosable: true,
            }}
        />
    )
})
